var map = {
	"./background.png": 1545,
	"./backimg.webp": 1546,
	"./bingo.png": 1148,
	"./bingomobile.png": 1547,
	"./chahua.png": 1548,
	"./enterprise.png": 1549,
	"./enterprisepc.png": 1550,
	"./headimage.png": 1201,
	"./nosatisfies.png": 1149,
	"./primarypc.png": 1551,
	"./senior.png": 1552,
	"./seniorpc.png": 1553,
	"./sticky-top.png": 1202,
	"./ultimate.png": 1554,
	"./ultimatepc.png": 1555
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1544;